<script lang="ts">
  import componentAttributes from '../stores/componentAttributes.svelte'
  import videoStore from '../stores/video.svelte'
</script>

{#if !componentAttributes.state.hidePoster && videoStore.state.mediaDescriptor?.posterUrl}
  <div
    class="absolute top-0 left-0 h-full w-full justify-center flex bg-black bg-center bg-cover"
    style={`background-image: url(${videoStore.state.mediaDescriptor?.posterUrl}`}
  ></div>
{/if}
